import Theme from 'utils/theme';

export const stepTypeValue = {
  REGISTRATION: 'Apply',
  KEEP_IN_VIEW: 'Keep In View',
  IN_REVIEW: 'In Review',
  SHORTLISTED: 'Shortlisted',
  CONDITIONAL_OFFER: 'Conditional Offer',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
};

export const stepTypeColor = {
  REGISTRATION: Theme.RegistrationStep,
  KEEP_IN_VIEW: Theme.KeepInViewStep,
  IN_REVIEW: Theme.InReviewStep,
  SHORTLISTED: Theme.ShortlistedStep,
  CONDITIONAL_OFFER: Theme.ConditionalOfferStep,
  ACCEPTED: Theme.AcceptedStep,
  DECLINED: Theme.DeclinedStep,
};

export const stepTypeIcon = {
  REGISTRATION: 'saf-group',
  KEEP_IN_VIEW: 'saf-eye-1',
  IN_REVIEW: 'saf-star',
  SHORTLISTED: 'saf-laptop',
  CONDITIONAL_OFFER: 'saf-circle',
  ACCEPTED: 'saf-ok-circle',
  DECLINED: 'saf-block',
};

export const StepTypes = Object.keys(stepTypeValue)
  .sort()
  .map((k) => ({ label: stepTypeValue[k], value: k }));

export const StepsWithEditablePayment = ['REGISTRATION'];
export const StepsWithPayment = ['REGISTRATION', 'CONDITIONAL_OFFER'];
export const StepsWithFixedPayment = ['CONDITIONAL_OFFER'];
export const StepsWithEmail = [
  'REGISTRATION',
  'CONDITIONAL_OFFER',
  'ACCEPTED',
  'DECLINED',
  'SHORTLISTED'
];

export const StepsWithDoc = ['ACCEPTED'];
export const StepsWithNotify = ['ACCEPTED', 'DECLINED', 'CONDITIONAL_OFFER', 'SHORTLISTED'];
export const StepsWithSMS = [];
export const stepsWithDuplicate = ['IN_REVIEW'];
export const StepsWithAutoProcess = ['REGISTRATION', 'IN_REVIEW'];
